import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Statistic, StatisticPerimeter } from 'src/app/core/_models/statistics';
import { UserRight } from 'src/app/core/_models/userRight';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/core/_services/auth.service';
import { SnackbarService } from 'src/app/core/_services/snackbar.service';
import { SpinnerOverlayService } from 'src/app/core/_services/spinner.overlay.service';
import { StatisticService } from 'src/app/core/_services/statistic.service';
import { UserService } from 'src/app/core/_services/user.service';

@Component({
  selector: 'app-statisticProfile',
  templateUrl: './statisticProfile.component.html',
  styleUrls: ['./statisticProfile.component.scss']
})
export class StatisticProfileComponent implements OnInit {
  startDateCEU!: Date;
  endDateCEU!: Date;
  profileCode!: string;
  agence!: any;
  agencys: StatisticPerimeter[] = [];
  selectedAgencyIds: string[] = [];

  constructor(
    private statisticService: StatisticService,
    private spinnerService: SpinnerOverlayService,
    private datePipe: DatePipe,
    private authService: AuthService,
    //private userService: UserService,
    private snackbarService: SnackbarService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    //this.spinnerService.show();

    let role = this.authService.roleValue;
    if (role) {
      this.statisticService.getSolutionsPerimeters().subscribe((arr) => {
        this.agencys = arr;
      });
    }

    //this.spinnerService.hide();
  }

  exportSolutionsUsageExcel() {
    if (this.startDateCEU != undefined && this.endDateCEU != undefined) {
      return this.statisticService.getSolutionsUsagesExport(this.datePipe.transform(this.startDateCEU, 'yyyy-MM-dd'), this.datePipe.transform(this.endDateCEU, 'yyyy-MM-dd'), this.selectedAgencyIds).subscribe(
        (data) => {
          if (data != null) this.downloadFile(data, 'exportsolutionseve.xlsx');
          else this.snackbarService.showMessage(this.translate.instant('error_no_data_returned'));
        },
        (err) => {
          this.snackbarService.showMessage(this.translate.instant('error_no_data_returned'));
        }
      );
    } else {
      this.snackbarService.showMessage(this.translate.instant('error_must_select_date'));
    }
  }

  downloadFile(data: Blob, fileName: string) {
    const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    const blob = new Blob([data], { type: contentType });
    let downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.setAttribute('download', fileName);
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }
}
